import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { firestore, storage } from "../../config/firebase";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { collection, addDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import CircularProgress from "@mui/material/CircularProgress";

const AddUniversity = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    if (extension === "svg") {
      form.setFields([
        {
          name: "image",
          errors: ["SVG image is not allowed"],
        },
      ]);
      return;
    }

    form.setFields([{ name: "image", errors: [] }]);
    setImageFile(file);
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    let imageUrl = "";
    try {
      if (!imageFile) {
        form.setFields([
          {
            name: "image",
            errors: ["Image is required"],
          },
        ]);
        setLoading(false);
        return;
      }

      const uniqueFilename = `${Date.now()}-${uuidv4()}`;
      const storageRef = ref(storage, `university/${uniqueFilename}`);
      const metadata = { contentType: imageFile.type };
      await uploadBytes(storageRef, imageFile, metadata);
      imageUrl = await getDownloadURL(storageRef);

      const newPost = {
        title: values.title,
        content: values.content,
        website: values.website ?? "",
        images: imageUrl,
        timestamp: Date.now(),
      };
      await addDoc(collection(firestore, "university"), newPost);

      form.resetFields();
      setImageFile(null);
      message.success("University added successfully!");
      navigate("/university");
    } catch (error) {
      const oldImageRef = ref(storage, imageUrl);
      deleteObject(oldImageRef).then((r) => {
        // alert("success");
      });
      console.error(error);
      message.error("Failed to add university. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 800, padding: 24 }}>
      <h2>Add University</h2>
      <Form
        form={form}
        onFinish={handleSubmit}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
        disabled={loading}
        layout="horizontal"
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[
            { required: true, message: "Title is required" },
            { max: 80, message: "Max 80 characters allowed" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Content"
          name="content"
          rules={[
            { required: true, message: "Content is required" },
            { max: 500, message: "Max 500 characters allowed" },
          ]}
        >
          <Input.TextArea rows={6} />
        </Form.Item>

        <Form.Item
          label="Website"
          name="website"
          // rules={[
          //   { required: true, message: "Website is required" },
          //   {
          //     type: "url",
          //     message: "Please enter a valid URL (e.g. https://example.com)",
          //   },
          // ]}
        >
          <Input placeholder="https://example.com" />
        </Form.Item>

        <Form.Item label="Image" name="image">
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            disabled={loading}
          />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
          {loading ? (
            <CircularProgress size={20} />
          ) : (
            <Button type="primary" htmlType="submit">
              Add University
            </Button>
          )}
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddUniversity;
